import Store from "App/Store.js";

export default (uuid, item) => Store.dispatch({type: "basketUpdate", uuid, item});
